import { render } from "./EmptyComponent.vue?vue&type=template&id=09270897&scoped=true"
import script from "./EmptyComponent.vue?vue&type=script&lang=js"
export * from "./EmptyComponent.vue?vue&type=script&lang=js"

import "./EmptyComponent.vue?vue&type=style&index=0&id=09270897&scoped=true&lang=css"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09270897"]])

export default __exports__